var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment-timezone';
import React from 'react';
import { ValidDateFormats } from '../../Shared/DateUtilities';
import styles from './Header.module.css';
var Title = function (props) {
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", { className: styles.display }, props.label)));
};
var InfoLine = function (props) {
    var updatedOn = moment(props.updatedOn).fromNow();
    var createdOn = moment(props.createdOn).format(ValidDateFormats.Display);
    return (React.createElement("div", { className: styles.infoContainer },
        React.createElement("div", { className: styles.info }, "Created " + createdOn + " \u00B7 Edited by " + props.updatedBy + " \u00B7 " + updatedOn)));
};
export var Header = function (props) {
    return (React.createElement("div", { className: styles.stickyHeader },
        React.createElement("div", { className: styles.headerContainer },
            React.createElement(Title, { label: props.title })),
        React.createElement(InfoLine, __assign({}, props))));
};
